import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faExpandArrowsAlt,
  faCompressArrowsAlt,
  faMoon,
  faSun,
} from '@fortawesome/free-solid-svg-icons';

import { useApp } from '../../providers/UserProvider';

const fullscreenElement = () =>
  document.fullscreenElement || document.webkitFullscreenElement || null;

const enterFullscreen = () => {
  const elem = document.documentElement;
  if (elem.requestFullscreen) elem.requestFullscreen();
  else if (elem.webkitRequestFullscreen) elem.webkitRequestFullscreen();
};

const exitFullscreen = () => {
  if (document.exitFullscreen) document.exitFullscreen();
  else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
};

// Classes da barra do topo: clara, ou escura no modo escuro
export const useNavbarTheme = () => {
  const { darkMode } = useApp();
  return darkMode ? 'navbar-dark' : 'navbar-white navbar-light';
};

/*
 * Os dois botões do canto direito de toda barra do topo: tela cheia e modo
 * claro/escuro. Entram como itens (<li>) dentro de um <ul className="navbar-nav">.
 */
function NavbarTools() {
  const { darkMode, toggleDarkMode } = useApp();
  const [isFullscreen, setIsFullscreen] = useState(!!fullscreenElement());

  useEffect(() => {
    const update = () => setIsFullscreen(!!fullscreenElement());
    document.addEventListener('fullscreenchange', update);
    document.addEventListener('webkitfullscreenchange', update);
    return () => {
      document.removeEventListener('fullscreenchange', update);
      document.removeEventListener('webkitfullscreenchange', update);
    };
  }, []);

  const handleFullscreen = e => {
    e.preventDefault();
    if (fullscreenElement()) exitFullscreen();
    else enterFullscreen();
  };

  const handleDarkMode = e => {
    e.preventDefault();
    toggleDarkMode();
  };

  return (
    <>
      <li className="nav-item">
        <a
          className="nav-link"
          href="/"
          role="button"
          title={isFullscreen ? 'Sair da tela cheia' : 'Tela cheia'}
          onClick={handleFullscreen}
        >
          <FontAwesomeIcon
            icon={isFullscreen ? faCompressArrowsAlt : faExpandArrowsAlt}
          />
        </a>
      </li>
      <li className="nav-item">
        <a
          className="nav-link"
          href="/"
          role="button"
          title={darkMode ? 'Modo claro' : 'Modo escuro'}
          onClick={handleDarkMode}
        >
          <FontAwesomeIcon icon={darkMode ? faSun : faMoon} />
        </a>
      </li>
    </>
  );
}

export default NavbarTools;
